(function(){
  function initRootHowToPour(){
    var root=document.querySelector('[data-root-how-to-pour]');
    if(!root||root.getAttribute('data-rpour-ready')==='true')return;
    root.setAttribute('data-rpour-ready','true');

    var flavorButtons=Array.prototype.slice.call(root.querySelectorAll('[data-pour-flavor]'));
    var modeButtons=Array.prototype.slice.call(root.querySelectorAll('[data-pour-mode]'));
    var recipes=Array.prototype.slice.call(root.querySelectorAll('[data-pour-recipe]'));
    var stage=root.querySelector('[data-pour-stage]');
    var status=root.querySelector('[data-pour-status]');
    var surprise=root.querySelector('[data-pour-surprise]');
    var activeFlavor=root.getAttribute('data-active-flavor')||'pineapple';
    var activeMode=root.getAttribute('data-active-mode')||'cocktail';

    var palette={
      pineapple:{accent:'#E8593D',soft:'#F6E4BA'},
      strawberry:{accent:'#BD1B5B',soft:'#F9CBDF'},
      pomegranate:{accent:'#BD1B5B',soft:'#FAC2BC'},
      grapefruit:{accent:'#066464',soft:'#B6E1DF'}
    };

    var hostData={
      pineapple:{
        cocktail:{primary:'aged rum',primaryPer:1.5,secondary:'Licor 43',secondaryPer:.5,finish:'Pineapple leaf or fresh lime'},
        zero:{primary:'coconut cream',primaryPer:.5,secondaryText:'Fresh lime to taste',finish:'Toasted coconut or nutmeg'}
      },
      strawberry:{
        cocktail:{primary:'vodka',primaryPer:1.5,secondary:'St-Germain',secondaryPer:.5,finish:'Fresh strawberry and lavender'},
        zero:{primary:'chilled white tea',primaryPer:1,secondaryText:'Fresh lemon and mint',finish:'Strawberry slice and mint'}
      },
      pomegranate:{
        cocktail:{primary:'London Dry Gin',primaryPer:1.5,secondary:'Aperol',secondaryPer:.25,finish:'Orange wheel and rosemary'},
        zero:{primary:'chilled hibiscus tea',primaryPer:1,secondaryText:'Fresh lemon and a pinch of sea salt',finish:'Orange peel and rosemary'}
      },
      grapefruit:{
        cocktail:{primary:'blanco tequila',primaryPer:1.5,secondary:'Ancho Reyes Verde',secondaryPer:.25,finish:'Grapefruit wedge and jalapeño'},
        zero:{primary:'coconut water',primaryPer:1,secondaryText:'Fresh lime and a pinch of sea salt',finish:'Grapefruit peel or cucumber ribbon'}
      }
    };

    function titleCase(value){return value.charAt(0).toUpperCase()+value.slice(1)}
    function findRecipe(flavor,mode){
      return recipes.find(function(recipe){return recipe.getAttribute('data-flavor')===flavor&&recipe.getAttribute('data-mode')===mode})
    }

    function setSelection(flavor,mode,options){
      options=options||{};
      if(!palette[flavor])flavor='pineapple';
      if(mode!=='cocktail'&&mode!=='zero')mode='cocktail';
      activeFlavor=flavor;
      activeMode=mode;
      root.setAttribute('data-active-flavor',flavor);
      root.setAttribute('data-active-mode',mode);
      root.style.setProperty('--active-accent',palette[flavor].accent);
      root.style.setProperty('--active-soft',palette[flavor].soft);

      flavorButtons.forEach(function(button){
        button.setAttribute('aria-pressed',button.getAttribute('data-pour-flavor')===flavor?'true':'false');
      });
      modeButtons.forEach(function(button){
        button.setAttribute('aria-pressed',button.getAttribute('data-pour-mode')===mode?'true':'false');
      });

      var selected=findRecipe(flavor,mode);
      recipes.forEach(function(recipe){
        var visible=recipe===selected;
        recipe.hidden=!visible;
        recipe.setAttribute('aria-hidden',visible?'false':'true');
      });

      if(selected&&status){
        var name=selected.getAttribute('data-recipe-name')||'Recipe';
        var flavorName=selected.getAttribute('data-flavor-name')||titleCase(flavor);
        status.textContent=name+' — '+flavorName+' '+(mode==='cocktail'?'cocktail':'zero-proof pour')+' selected.';
      }

      if(options.syncHost!==false){
        var hostFlavor=root.querySelector('[data-host-flavor]');
        var hostMode=root.querySelector('[data-host-mode]');
        if(hostFlavor)hostFlavor.value=flavor;
        if(hostMode)hostMode.value=mode;
        updateHosting();
      }
    }

    flavorButtons.forEach(function(button){
      button.addEventListener('click',function(){setSelection(button.getAttribute('data-pour-flavor'),activeMode)});
    });
    modeButtons.forEach(function(button){
      button.addEventListener('click',function(){setSelection(activeFlavor,button.getAttribute('data-pour-mode'))});
    });

    if(surprise){
      surprise.addEventListener('click',function(){
        var flavors=Object.keys(palette);
        var modes=['cocktail','zero'];
        var nextFlavor=flavors[Math.floor(Math.random()*flavors.length)];
        var nextMode=modes[Math.floor(Math.random()*modes.length)];
        if(nextFlavor===activeFlavor&&nextMode===activeMode){
          nextFlavor=flavors[(flavors.indexOf(nextFlavor)+1)%flavors.length];
        }
        setSelection(nextFlavor,nextMode);
        var selected=findRecipe(nextFlavor,nextMode);
        if(selected)selected.focus({preventScroll:true});
      });
    }

    function recipeText(article){
      var lines=[];
      var name=article.querySelector('h3');
      if(name)lines.push(name.textContent.trim());
      var intro=article.querySelector('.rpour-recipe__intro');
      if(intro)lines.push(intro.textContent.trim());
      lines.push('');
      lines.push('Ingredients:');
      Array.prototype.slice.call(article.querySelectorAll('[data-recipe-ingredients] li')).forEach(function(item){lines.push('• '+item.textContent.trim())});
      lines.push('');
      lines.push('Method:');
      Array.prototype.slice.call(article.querySelectorAll('[data-recipe-method] li')).forEach(function(item,index){lines.push((index+1)+'. '+item.textContent.trim())});
      var garnish=article.querySelector('[data-recipe-garnish]');
      if(garnish){lines.push('');lines.push('Garnish: '+garnish.textContent.trim())}
      lines.push('');
      lines.push('Root Elixirs — rootelixirs.com');
      return lines.join('\n');
    }

    function fallbackCopy(text){
      var area=document.createElement('textarea');
      area.value=text;
      area.setAttribute('readonly','');
      area.style.position='fixed';
      area.style.opacity='0';
      document.body.appendChild(area);
      area.select();
      var copied=false;
      try{copied=document.execCommand('copy')}catch(error){copied=false}
      document.body.removeChild(area);
      return copied;
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-copy-recipe]')).forEach(function(button){
      button.addEventListener('click',function(){
        var article=button.closest('[data-pour-recipe]');
        if(!article)return;
        var text=recipeText(article);
        var original=button.getAttribute('data-original-label')||button.textContent;
        button.setAttribute('data-original-label',original);
        var done=function(success){
          button.textContent=success?'Copied!':'Copy manually';
          window.setTimeout(function(){button.textContent=original},1800);
        };
        if(navigator.clipboard&&window.isSecureContext){
          navigator.clipboard.writeText(text).then(function(){done(true)}).catch(function(){done(fallbackCopy(text))});
        }else{
          done(fallbackCopy(text));
        }
      });
    });

    var guestRange=root.querySelector('[data-host-guests]');
    var guestValue=root.querySelector('[data-host-guest-value]');
    var hostFlavor=root.querySelector('[data-host-flavor]');
    var hostMode=root.querySelector('[data-host-mode]');
    var hostCans=root.querySelector('[data-host-cans]');
    var hostPrimary=root.querySelector('[data-host-primary]');
    var hostSecondary=root.querySelector('[data-host-secondary]');
    var hostFinish=root.querySelector('[data-host-finish]');
    var hostSummary=root.querySelector('[data-host-summary]');
    var hostMinus=root.querySelector('[data-host-minus]');
    var hostPlus=root.querySelector('[data-host-plus]');
    var hostView=root.querySelector('[data-host-view]');

    function formatNumber(number){
      return new Intl.NumberFormat('en-US',{maximumFractionDigits:2}).format(Math.round(number*100)/100);
    }

    function updateHosting(){
      if(!guestRange||!hostFlavor||!hostMode)return;
      var guests=parseInt(guestRange.value,10)||2;
      var flavor=hostFlavor.value;
      var mode=hostMode.value;
      var data=hostData[flavor]&&hostData[flavor][mode];
      if(!data)return;
      if(guestValue)guestValue.textContent=guests;
      guestRange.setAttribute('aria-valuetext',guests+' guests');
      if(hostCans)hostCans.textContent=guests+' chilled '+(guests===1?'can':'cans');
      if(hostPrimary)hostPrimary.textContent=formatNumber(data.primaryPer*guests)+' oz '+data.primary;
      if(hostSecondary){
        hostSecondary.textContent=data.secondaryPer?formatNumber(data.secondaryPer*guests)+' oz '+data.secondary:data.secondaryText;
      }
      if(hostFinish)hostFinish.textContent=data.finish;
      if(hostSummary){
        var style=mode==='cocktail'?'cocktails':'zero-proof drinks';
        hostSummary.textContent='For '+guests+' '+style+': prep the base ahead, keep '+guests+' Root Elixirs cans cold, and add the sparkling mixer when you are ready to serve.';
      }
    }

    [guestRange,hostFlavor,hostMode].forEach(function(control){if(control)control.addEventListener('input',updateHosting)});
    if(hostMinus){hostMinus.addEventListener('click',function(){guestRange.value=Math.max(parseInt(guestRange.min,10),parseInt(guestRange.value,10)-1);updateHosting()})}
    if(hostPlus){hostPlus.addEventListener('click',function(){guestRange.value=Math.min(parseInt(guestRange.max,10),parseInt(guestRange.value,10)+1);updateHosting()})}
    if(hostView){
      hostView.addEventListener('click',function(){
        setSelection(hostFlavor.value,hostMode.value);
        if(stage)stage.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
      });
    }

    Array.prototype.slice.call(root.querySelectorAll('[data-pour-faq] details')).forEach(function(detail){
      detail.addEventListener('toggle',function(){
        if(!detail.open)return;
        Array.prototype.slice.call(root.querySelectorAll('[data-pour-faq] details')).forEach(function(other){if(other!==detail)other.open=false});
      });
    });

    setSelection(activeFlavor,activeMode);
    updateHosting();
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initRootHowToPour);else initRootHowToPour();
  document.addEventListener('shopify:section:load',initRootHowToPour);
})();
